import React from 'react';
import { withRouter } from 'react-router-dom';
import { withLastLocation } from 'react-router-last-location';
import PropTypes from 'prop-types';

import Link from '@marvelapp/marvel-ui/link';
import Align from '@marvelapp/marvel-ui/align';
import Button from '@marvelapp/marvel-ui/button';
import Heading from '@marvelapp/marvel-ui/heading';
import MaxWidth from '@marvelapp/marvel-ui/max-width';
import Position from '@marvelapp/marvel-ui/position';
import Spacing from '@marvelapp/marvel-ui/spacing';

import ArrowButton from 'marketing-website/components/commons/ArrowButton';
import MarvelLogo from 'marketing-website/components/commons/MarvelLogo';

import styles from './style/general.module.css';

/* eslint-disable react/prop-types */
function Table({ children }) {
  return <div className={styles.table}>{children}</div>;
}

function LeftCol({ children }) {
  return <div className={styles.left}>{children}</div>;
}

function RightCol({ children, isSignUpPage }) {
  return (
    <div className={styles.right}>
      {isSignUpPage ? (
        <div className={styles.pattern}>
          <div className={styles.centerAligned}>{children}</div>
        </div>
      ) : (
        <div className={styles.rightColumn}>
          <div className={styles.bottomAligned}>{children}</div>
        </div>
      )}
    </div>
  );
}

/* eslint-enable react/prop-types */
function AccountPagesWrap({ children, history, isSignUpPage, lastLocation }) {
  const buttonProps = {
    size: 'large',
    color: 'slate',
    hover: 'white',
    kind: 'ghost',
  };

  const goBack = () => {
    if (lastLocation === null) {
      history.push('/');
    } else {
      history.goBack();
    }
  };

  return (
    <div className={styles.wrapper}>
      <Position location="all">
        <Table>
          <LeftCol>
            <Position location="topLeft">
              <Spacing type="padding" size="m">
                <ArrowButton isReversed onClick={() => goBack()} />
              </Spacing>
            </Position>
            <div className={styles.logo}>
              <Spacing type="margin" position="topBottom" size="m">
                <Link to="/">
                  <MarvelLogo display="inlineBlock" />
                </Link>
              </Spacing>
            </div>

            <Spacing type="margin" position="topBottom" sizeM="l">
              {children[0] || children}
            </Spacing>

            <Spacing type="margin" position="topBottom" size="m">
              {children[1]}
            </Spacing>
          </LeftCol>

          <RightCol isSignUpPage={isSignUpPage}>
            {!isSignUpPage && (
              <Spacing type="margin" size="m">
                <Align type="center">
                  <Spacing type="margin" size="xs" position="bottom">
                    <Spacing type="padding" size="xxs" position="bottom">
                      <MaxWidth value={400}>
                        <Heading
                          tag="h2"
                          size="xxl"
                          weight="bold"
                          color="black"
                        >
                          Meet Ballpark, the incredible new research platform by
                          Marvel
                        </Heading>
                      </MaxWidth>
                    </Spacing>

                    <Spacing type="padding" size="xs" position="bottom">
                      <MaxWidth value={500}>
                        <Heading
                          tag="h3"
                          size="l"
                          weight="regular"
                          color="black"
                        >
                          Ballpark is the fastest way to capture high-quality
                          feedback on questions, marketing copy, designs and
                          prototypes
                        </Heading>
                      </MaxWidth>
                    </Spacing>

                    <Spacing type="padding" size="xs" position="top">
                      <Link
                        url="https://ballparkhq.com/?utm_campaign=Ballpark%20Launch%200622&utm_source=Marvel%20website&utm_medium=Login%20page"
                        target="_blank"
                      >
                        <Button {...buttonProps}>Get started</Button>
                      </Link>
                    </Spacing>
                  </Spacing>
                </Align>
              </Spacing>
            )}
          </RightCol>
        </Table>
      </Position>
    </div>
  );
}

export default withLastLocation(withRouter(AccountPagesWrap));

AccountPagesWrap.propTypes = {
  children: PropTypes.array.isRequired,
  isSignUpPage: PropTypes.bool,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  lastLocation: PropTypes.object.isRequired,
};

AccountPagesWrap.defaultProps = {
  isSignUpPage: false,
};



// WEBPACK FOOTER //
// ./src/components/modules/AccountPagesWrap/index.js